import {ref} from 'vue';
import hash from '../helper/hash'

let collection = ref({});
let filter = ref(null);
let active = ref(null);
let show = ref(true);
let scroll = ref(null);

async function getCollection(filter = null) {
    let md5 = null;

    if(filter.directory == 'bookmarks' && active.value){
        return;
    }
    if (filter) {
        md5 = hash.md5(JSON.stringify(filter));
    }
    if (collection.value[md5] != undefined) {
        active.value = collection.value[md5];
        console.log('active', collection.value[md5]);
    } else {
        $api.app.getDirectoryNavigation(filter).then(resp => {
            collection.value[md5] = resp.data;
            console.log('load', collection.value[md5]);
            active.value = resp.data;
        })
    }
    scroll.value = md5;
}

export default {
    collection, getCollection, active, show, filter,scroll
}


